var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconStargaze = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.587 11.72 2.352-1.358-3.06-5.301-2.352 1.358 3.06 5.3zm-5.022-5.053a1.225 1.225 0 0 1 .516-1.534l3.412-1.97a1.224 1.224 0 0 1 1.672.448l3.671 6.36a1.224 1.224 0 0 1-.447 1.672l-3.412 1.97a1.224 1.224 0 0 1-1.671-.447l-.02-.031-1.629.884c.023.153.035.31.035.47 0 .769-.283 1.473-.754 2.008l1.909 4.682a.918.918 0 1 1-1.702.692l-1.798-4.41a3.163 3.163 0 0 1-1.438 0l-1.798 4.41a.918.918 0 1 1-1.702-.692l1.694-4.162-3.38 1.829a1.223 1.223 0 0 1-1.642-.463l-.026-.05-1.69.975a.919.919 0 0 1-1.255-.336l-.987-1.718A.919.919 0 0 1 2.459 16l1.687-.976-.153-.256a1.222 1.222 0 0 1 .405-1.644l10.167-6.457zm2.804 4.877-1.894-3.278-9.596 6.093 1.495 2.59 3.274-1.772a3.174 3.174 0 0 1-.076-.692 3.059 3.059 0 0 1 5.27-2.115l1.527-.826zm-3.737 4.165a1.224 1.224 0 1 0 0-2.448 1.224 1.224 0 0 0 0 2.448z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconStargaze, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-stargaze.5e09b644.svg";
export { ForwardRef as ReactComponent };